/**
 * Transcript search form and download
 */

import { h } from "preact";
import { useContext, useState } from "preact/hooks";
import SearchContext from "../../features/utils/SearchContext";
import { Input, Button } from "../../shared/components";

// This is not a good import from the global module again; refactor this.
import { useRecordedURL } from "../../helpers/routes";
import SettingsContext from "../../SettingsContext";

interface SearchFormProps {
  id: string;
  enabled: boolean;
  selectedLang: string;
}

const SearchForm = (props: SearchFormProps) => {
  const { id, enabled, selectedLang } = props;

  const { setSearchString } = useContext(SearchContext);
  const [inputValue, setInputValue] = useState<string>("");

  const { settings } = useContext(SettingsContext);

  const settingsUrl = useRecordedURL("/transcript", {
    format: "tx-pdf",
    preferred_languages: [selectedLang],
  });

  const handleSubmit = (e: Event) => {
    e.preventDefault();
  };

  return (
    <div
      class={
        enabled
          ? "SearchForm-wrapper fullWidth flex jcEnd"
          : "SearchForm-wrapper SearchForm-wrapper-isHidden"
      }
    >
      <form
        id={id}
        class={
          enabled
            ? "flex posRelative SearchForm-form"
            : "SearchForm-form SearchForm-form-isHidden"
        }
        onSubmit={(e) => {
          handleSubmit(e);
          setSearchString(inputValue);
        }}
      >
        <Input
          formItemStyle="fullWidth"
          inputStyle="SearchForm-input"
          type="search"
          id="search"
          label="Search transcript"
          labelHidden
          placeholder="Search..."
          onChange={(val) => setInputValue(val)}
        />
        <Button
          className="SearchForm-button"
          formId="keyword-search"
          id="search-submit"
          tag="button"
          iconType="search"
          label="Submit Search"
          type="submit"
          labelHidden
          iconStyle="SearchForm-icon"
        />
      </form>
      {settings.showDownload && (
        <Button
          className="SearchForm-download"
          title="Download Transcript"
          id="download-pdf"
          tag="a"
          iconType="download"
          label="Download PDF"
          labelHidden
          iconStyle="SearchForm-icon"
          download
          href={settingsUrl.toString()}
        />
      )}
    </div>
  );
};

export default SearchForm;
